var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaroLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 38,
    viewBox: "0 0 145 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_17_37347)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.455 26H19.6165C20.6972 26 20.8173 25.88 20.8173 24.8002V23.6005C20.8173 22.5208 20.8686 22.3621 22.0181 22.3945L21.2214 21.2711C20.8691 22.3262 20.6972 22.4008 19.6165 22.4008H19.0161C17.9354 22.4008 17.7853 22.2808 17.425 21.2611L14.393 12.1432C14.0327 11.1234 13.8826 11.0034 12.8019 11.0034H11.0007C9.91995 11.0034 9.82988 11.1234 10.1901 12.1432L14.2729 23.7205C14.7832 25.2201 15.894 26 17.455 26Z",
    fill: "#1A1A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8301 23.5963C20.8301 22.5169 20.9463 22.397 22.0246 22.397H23.5223C24.6006 22.397 24.7504 22.277 25.1398 21.2576L26.7688 16.6297L23.5695 14.0923L21.2159 21.2576C20.8564 22.277 20.7066 22.397 19.6283 22.397L20.8301 23.5963Z",
    fill: "#5FCF86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5696 14.0924L26.7689 16.6298L28.4375 12.1253C28.8316 11.1184 28.7406 11 27.6495 11H25.8308C24.7397 11 24.5881 11.1184 24.2244 12.1253L23.5696 14.0924Z",
    fill: "#EA5C29"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 12.1606H47.0901L50.7478 21.7285L54.3817 12.1606H56.4243L51.8878 23.8623H49.5365L45 12.1606Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8781 12.1606H59.8257V23.8623H57.8781V12.1606Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0139 20.0076C64.0456 20.7113 64.3623 21.2849 64.964 21.7285C65.5815 22.1721 66.3732 22.3939 67.3391 22.3939C68.1941 22.3939 68.8829 22.2333 69.4054 21.912C69.9438 21.5755 70.213 21.1396 70.213 20.6042C70.213 20.1453 70.0863 19.7935 69.8329 19.5488C69.5796 19.304 69.2471 19.1358 68.8354 19.044C68.4395 18.9522 67.8695 18.8604 67.1253 18.7686C66.0803 18.6463 65.2252 18.4857 64.5602 18.2868C63.8952 18.088 63.3568 17.7744 62.9451 17.3461C62.5334 16.9025 62.3276 16.2983 62.3276 15.5335C62.3276 14.8451 62.5255 14.2333 62.9214 13.6979C63.333 13.1625 63.8872 12.7495 64.5839 12.4589C65.2806 12.153 66.0644 12 66.9353 12C68.3604 12 69.5163 12.3212 70.403 12.9637C71.3055 13.6061 71.8043 14.5239 71.8993 15.717H69.9517C69.8725 15.1052 69.5638 14.6004 69.0254 14.2027C68.487 13.805 67.8141 13.6061 67.0066 13.6061C66.1832 13.6061 65.5181 13.7744 65.0115 14.1109C64.5048 14.4321 64.2514 14.8604 64.2514 15.3958C64.2514 15.7935 64.3702 16.0994 64.6077 16.3136C64.8452 16.5277 65.146 16.673 65.5102 16.7495C65.8903 16.826 66.4603 16.9101 67.2203 17.0019C68.2812 17.1243 69.1521 17.2925 69.8329 17.5067C70.5296 17.7208 71.0838 18.065 71.4955 18.5392C71.923 19.0134 72.1368 19.6558 72.1368 20.4665C72.1368 21.1702 71.923 21.7897 71.4955 22.325C71.068 22.8604 70.4901 23.2734 69.7617 23.5641C69.0333 23.8547 68.2258 24 67.3391 24C65.7557 24 64.481 23.6482 63.5151 22.9446C62.5651 22.2409 62.0821 21.262 62.0663 20.0076H64.0139Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6755 22.1415V23.8623H84.6067C83.8308 23.8623 83.2766 23.7094 82.9441 23.4034C82.6116 23.0975 82.4374 22.6463 82.4216 22.0497C81.4874 23.3499 80.1336 24 78.3602 24C77.0143 24 75.9296 23.6941 75.1063 23.0822C74.2987 22.4704 73.8949 21.6367 73.8949 20.5813C73.8949 19.4034 74.3066 18.501 75.13 17.8738C75.9692 17.2467 77.1805 16.9331 78.7639 16.9331H82.3266V16.13C82.3266 15.3652 82.0574 14.7686 81.5191 14.3403C80.9965 13.912 80.2602 13.6979 79.3102 13.6979C78.471 13.6979 77.7743 13.8815 77.2201 14.2486C76.6817 14.6004 76.3492 15.0746 76.2226 15.6711H74.275C74.4175 14.5239 74.94 13.6291 75.8425 12.9866C76.7609 12.3442 77.9485 12.0229 79.4052 12.0229C80.957 12.0229 82.1524 12.3901 82.9916 13.1243C83.8467 13.8432 84.2742 14.8834 84.2742 16.2447V21.2925C84.2742 21.8585 84.5434 22.1415 85.0817 22.1415H85.6755ZM82.3266 18.5163H78.5739C76.7688 18.5163 75.8663 19.1663 75.8663 20.4665C75.8663 21.0478 76.1038 21.5143 76.5788 21.8662C77.0538 22.218 77.6951 22.3939 78.5027 22.3939C79.6902 22.3939 80.6244 22.0956 81.3053 21.499C81.9862 20.8872 82.3266 20.0841 82.3266 19.0899V18.5163Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3243 12.1606V13.9962H92.3505C91.1946 13.9962 90.3633 14.3709 89.8566 15.1205C89.3658 15.87 89.1204 16.7954 89.1204 17.8967V23.8623H87.1728V12.1606H88.8591L89.1204 13.9273C89.4687 13.392 89.92 12.9637 90.4742 12.6424C91.0284 12.3212 91.7963 12.1606 92.778 12.1606H93.3243Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.991 24C98.8192 24 97.7742 23.7476 96.8558 23.2428C95.9533 22.7381 95.2486 22.0344 94.742 21.1319C94.2353 20.2294 93.9819 19.1893 93.9819 18.0115C93.9819 16.8337 94.2353 15.7935 94.742 14.891C95.2486 13.9885 95.9533 13.2849 96.8558 12.7801C97.7742 12.2753 98.8192 12.0229 99.991 12.0229C101.163 12.0229 102.2 12.2753 103.102 12.7801C104.021 13.2849 104.733 13.9885 105.24 14.891C105.747 15.7935 106 16.8337 106 18.0115C106 19.1893 105.747 20.2294 105.24 21.1319C104.733 22.0344 104.021 22.7381 103.102 23.2428C102.2 23.7476 101.163 24 99.991 24ZM99.991 22.325C100.783 22.325 101.479 22.1415 102.081 21.7744C102.699 21.4073 103.174 20.8948 103.506 20.2371C103.839 19.5794 104.005 18.8375 104.005 18.0115C104.005 17.1855 103.839 16.4436 103.506 15.7859C103.174 15.1281 102.699 14.6157 102.081 14.2486C101.479 13.8815 100.783 13.6979 99.991 13.6979C99.1993 13.6979 98.4946 13.8815 97.8771 14.2486C97.2754 14.6157 96.8083 15.1281 96.4758 15.7859C96.1433 16.4436 95.977 17.1855 95.977 18.0115C95.977 18.8375 96.1433 19.5794 96.4758 20.2371C96.8083 20.8948 97.2754 21.4073 97.8771 21.7744C98.4946 22.1415 99.1993 22.325 99.991 22.325Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_17_37347",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_37347"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_17_37347",
    result: "effect2_dropShadow_17_37347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_17_37347",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaroLogoWhite);
export default __webpack_public_path__ + "static/media/visaro-logo-white.c7bddb19b9255ac6de54ce9f5a2c795e.svg";
export { ForwardRef as ReactComponent };